import Vue from 'vue';
import './plugins/vuetify';
import { domain, clientId, audience } from './auth/auth0-variables.json';

// Import the plugin here
import { Auth0Plugin } from './auth/authWrapper';

import App from './App.vue';

import store from './store';
// import "@/components/_globals";

import router from './router';
import LogRocket from 'logrocket';

import StoreMixin from './mixins/store.mixin';

import { VueLd } from 'vue-ld';

import './utils/validators';

import { EventBus } from './utils/event-bus';
Vue.prototype.$eventBus = EventBus;

Vue.use(VueLd, {
  clientSideId: process.env.LAUNCHDARKLY,
  user: {
    anonymous: true,
  },
  readyBeforeIdentify: false,
});

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
});

Vue.mixin(StoreMixin);

import VueAnalytics from 'vue-analytics';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
if (process.env.ENVIRONMENT !== 'development') {
  Sentry.init({
    environment: process.env.ENVIRONMENT,
    dsn: process.env.RAVEN,
    ignoreErrors: ['Non-Error promise rejection captured'],
    integrations: [
      new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
    ],
  });
  LogRocket.getSessionURL((sessionURL) => {
    Sentry.configureScope((scope) => {
      scope.setExtra('sessionURL', sessionURL);
    });
  });
}
const isProd = process.env.NODE_ENV === 'production';
Vue.config.productionTip = !isProd;
const isDev = process.env.NODE_ENV == 'development';
if (!isDev) LogRocket.init('uotsmx/sog');

Vue.use(VueAnalytics, {
  id: process.env.GOOGLE,
  router,
  autoTracking: {
    exception: true,
    //screenview: true
  },
  debug: {
    enabled: false,
    sendHitTask: isProd,
  },
});

const app = new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');

window.quoteToolFlag = false;
